import type { PaymentClaim } from '@/api/payments';
import { Badge } from '@/components/ui/badge';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { formatDateTime, money } from '@/lib/utils';

const STATUS_VARIANT = { Pending: 'low', Approved: 'ok', Rejected: 'out' } as const;

export function ClaimsHistoryList({ claims }: { claims: PaymentClaim[] }) {
  if (claims.length === 0) return null;

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-base">Your claims</CardTitle>
      </CardHeader>
      <CardContent className="space-y-2">
        {claims.map((claim) => (
          <div key={claim.id} className="rounded-md bg-secondary/50 p-3 text-sm">
            <div className="flex items-center justify-between">
              <span className="tabular font-semibold">{money(claim.amount)}</span>
              <Badge variant={STATUS_VARIANT[claim.status]}>{claim.status}</Badge>
            </div>
            <p className="mt-0.5 text-xs text-muted-foreground">
              {claim.method}
              {claim.transactionRef && ` · UTR ${claim.transactionRef}`}
              {' · '}
              {formatDateTime(claim.createdAt)}
            </p>
            {claim.reviewNote && (
              <p className="mt-1 text-xs text-muted-foreground">Note: {claim.reviewNote}</p>
            )}
          </div>
        ))}
      </CardContent>
    </Card>
  );
}
